<div class="duplicate-quote-container">
  <h4 class="dialog-title">{{ "DUPLICATE_QUOTE.TITLE" | translate }}: {{ quoteDisplayId() }} - {{ selectedVersionName() }}</h4>

  <p-stepper [value]="activeStep()" [linear]="true">
    <p-step-list>
      <p-step [value]="1">{{ 'DUPLICATE_QUOTE.SALESPERSON' | translate }}</p-step>
      <p-step [value]="2">{{ 'DUPLICATE_QUOTE.ATTIO_DEAL' | translate }}</p-step>
      <p-step [value]="3">{{ 'DUPLICATE_QUOTE.SUMMARY' | translate }}</p-step>
    </p-step-list>

    <p-step-panels>
      <!-- STEP 1: SELECT SALESPERSON, whose open Attio deals are offered next -->
      <p-step-panel [value]="1">
        <ng-template #content>
          <form [formGroup]="stepSalesPerson" class="step-content">
            <div class="yllw-form-field">
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <p-floatlabel variant="on">
                  <p-select inputId="salesPerson" formControlName="salesPerson" [options]="salesPersons()"
                    optionLabel="name" [showClear]="true" styleClass="w-full">
                    <ng-template let-salesPerson #item>
                      <div class="flex justify-content-between align-items-center w-full">
                        <span>{{ salesPerson.name }}</span>
                        @if (salesPerson.code) {
                        <span class="option-info-text">{{ salesPerson.code }}</span>
                        }
                      </div>
                    </ng-template>
                  </p-select>
                  <label for="salesPerson">{{ "DUPLICATE_QUOTE.SELECT_SALESPERSON" | translate }}</label>
                </p-floatlabel>
              </p-inputgroup>
            </div>
            <p class="warning-text">{{ "DUPLICATE_QUOTE.SELECT_SALESPERSON_WARNING" | translate }}</p>
            <div class="step-actions">
              <p-button [label]="'DUPLICATE_QUOTE.BTN_NEXT' | translate" severity="primary"
                [disabled]="!stepSalesPerson.valid" (onClick)="nextStep()" />
            </div>
          </form>
        </ng-template>
      </p-step-panel>

      <!-- STEP 2: SELECT ATTIO DEAL, which decides the copy's customer -->
      <p-step-panel [value]="2">
        <ng-template #content>
          <form [formGroup]="stepDeal" class="step-content">
            <app-select-attio-deal [control]="dealControl" [requireCustomer]="true"
              [preselectRecordId]="sourceDealRecordId()" [salesPerson]="salesPerson()" />

            <!-- OPPORTUNITY NAME, prefilled from the deal -->
            <div class="yllw-form-field mt-4">
              <p-floatlabel variant="on">
                <input id="newOpportunityName" type="text" pInputText formControlName="newOpportunityName"
                  class="w-full" />
                <label for="newOpportunityName">{{ "DUPLICATE_QUOTE.QUOTE_NAME" | translate }}</label>
              </p-floatlabel>
              <app-core-errors [control]="stepDeal.get('newOpportunityName')"></app-core-errors>
            </div>

            <div class="step-actions">
              <p-button [label]="'DUPLICATE_QUOTE.BTN_BACK' | translate" severity="secondary" [outlined]="true"
                (onClick)="prevStep()" />
              <p-button [label]="'DUPLICATE_QUOTE.BTN_NEXT' | translate" severity="primary"
                [disabled]="!stepDeal.valid" (onClick)="nextStep()" />
            </div>
          </form>
        </ng-template>
      </p-step-panel>

      <!-- STEP 3: SUMMARY -->
      <p-step-panel [value]="3">
        <ng-template #content>
          <div class="step-content">
            <div class="summary-section">
              <h6>{{ "DUPLICATE_QUOTE.SELECTED_CUSTOMER" | translate }}</h6>
              <p>
                {{ dealControl.value?.companyName }}
                <span class="option-info-text">{{ dealControl.value?.customerCode }}</span>
              </p>
            </div>
            <div class="summary-section">
              <h6>{{ "DUPLICATE_QUOTE.SELECTED_ATTIO_DEAL" | translate }}</h6>
              <p>
                {{ dealControl.value?.name }}
                @if (dealControl.value?.companyName) {
                <span>— {{ dealControl.value?.companyName }}</span>
                }
              </p>
              <h6>{{ "DUPLICATE_QUOTE.QUOTE_NAME" | translate }}</h6>
              <p>{{ stepDeal.get("newOpportunityName")?.value }}</p>
            </div>
            <div class="summary-section">
              <h6>{{ "DUPLICATE_QUOTE.SELECTED_SALESPERSON" | translate }}</h6>
              <p>
                {{ salesPersonControl.value?.name }}
                @if (salesPersonControl.value?.code) {
                <span>({{ salesPersonControl.value?.code }})</span>
                }
              </p>
            </div>
            <div class="summary-actions">
              <p-button [label]="'DUPLICATE_QUOTE.BTN_BACK' | translate" severity="secondary" [outlined]="true"
                (onClick)="prevStep()" />
              @if (!isSubmitting()) {
              <p-button [label]="'DUPLICATE_QUOTE.CREATE_DUPLICATE' | translate" severity="primary"
                (onClick)="onSubmit()" [disabled]="!form.valid" />
              }
              @if (isSubmitting()) {
              <p-progressSpinner [style]="{width: '40px', height: '40px'}" />
              }
            </div>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>